import { render, staticRenderFns } from "./OrderSelector.vue?vue&type=template&id=2902819d&"
import script from "./OrderSelector.vue?vue&type=script&lang=js&"
export * from "./OrderSelector.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelector.vue?vue&type=style&index=0&id=2902819d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports